import React from "react";
import {CheckIcon} from "@heroicons/react/24/outline";
import {FormattedMessage} from "react-intl";

const Steps = ({
  current,  // number
  steps,    // array of strings
}) => {

  // utilities
  const objs = steps
    .map((key, idx) => ({
      name: <FormattedMessage id={key} />,
      status: idx < current
        ? 'complete'
        : idx === current
          ? 'current'
          : 'upcoming',
    }))

  // utilities
  const renderStep = ({name, status}) => {

    const background = status === "complete"
      ? "bg-am-700"
      : `border-2 bg-white ${status === "current" ? "border-am-700" : "border-gray-200"}`;

    return <>
      <div className="absolute inset-0 flex items-center" aria-hidden="true">
        <div className={`h-0.5 w-full ${status === "complete" ? "bg-am-700" : "bg-gray-200"}`} />
      </div>
      <div
        className={`relative flex h-5 w-5 items-center justify-center rounded-full ${background}`}
      >
        {status === 'complete'
          ? <CheckIcon className="w-2.5 stroke-2 text-white" aria-hidden="true" />
          : <span
            className={`h-2 w-2 rounded-full ${status === "current" ? "bg-am-700" : "bg-transparent"}`}
            aria-hidden="true"
          />
        }
        <span
          className={`text-xxs uppercase absolute ${status === "upcoming" ? "text-gray-400" : "font-medium text-am-700"}`}
          style={{bottom: status === "complete" ? "-1.2rem" : "-1.3rem"}}
        >
          {name}
        </span>
      </div>
    </>
  }

  // Original component: https://tailwindui.com/components/application-ui/navigation/steps#component-9a29a1d37a37b90f0b926478e8706004
  return (
    <nav aria-label="Progress">
      <ol role="list" className="flex items-center">
        {objs.map((step, stepIdx) => (
          <li key={stepIdx} className={`relative ${stepIdx !== objs.length - 1 ? 'pr-8 sm:pr-20' : ''}`}>
            {renderStep(step)}
          </li>
        ))}
      </ol>
    </nav>
  )
}

export default Steps;